import * as React from 'react';
import * as SliderPrimitive from '@radix-ui/react-slider';

import { cn } from './cn';

// Closed slider primitive — single-thumb, fixed 0–100 range, step 1.
// Caller passes `value` (number) and `onChange(value)`. Tone controls
// the fill colour and thumb border (primary or secondary brand).
//
// Radix Slider's native contract is array-based to support multi-thumb;
// we wrap that internally (scalar ↔ [scalar]) so callers never see the
// array. If a real range-slider use case ever lands, lift the array
// shape from that callsite or add a sibling <RangeSlider>.

const TONE_FILL_CLASSNAMES = {
    primary: 'tw-bg-primary',
    secondary: 'tw-bg-secondary'
};

const TONE_THUMB_BORDER_CLASSNAMES = {
    primary: 'tw-border-primary',
    secondary: 'tw-border-secondary'
};

const Slider = React.forwardRef(({
    className: _className,
    style: _style,
    onChange,
    tone = 'primary',
    value
}, ref) => (
    <SliderPrimitive.Root
        ref={ref}
        className="tw-relative tw-flex tw-w-full tw-touch-none tw-select-none tw-items-center"
        max={100}
        min={0}
        onValueChange={([next]) => onChange?.(next)}
        step={1}
        value={[value]}
    >
        <SliderPrimitive.Track className="tw-relative tw-h-2 tw-w-full tw-grow tw-overflow-hidden tw-rounded-full tw-bg-muted">
            <SliderPrimitive.Range className={cn('tw-absolute tw-h-full', TONE_FILL_CLASSNAMES[tone])} />
        </SliderPrimitive.Track>
        <SliderPrimitive.Thumb className={cn('tw-block tw-h-4 tw-w-4 tw-rounded-full tw-border-2 tw-bg-background tw-shadow-none tw-transition-colors focus:tw-outline-none focus-visible:tw-outline-none', TONE_THUMB_BORDER_CLASSNAMES[tone])} />
    </SliderPrimitive.Root>
));

Slider.displayName = 'Slider';

export { Slider };
